module.exports = __webpack_public_path__ + "img/2.57ed9746.jpg";